
import React from "react";
import { ImageIcon, VideoIcon } from "lucide-react";
import { FileInput } from "@/components/ui/file-input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface EvidenceUploaderProps {
  imageFiles: File[];
  videoFiles: File[];
  onAddImages: (files: File[]) => void;
  onRemoveImage: (index: number) => void;
  onAddVideos: (files: File[]) => void;
  onRemoveVideo: (index: number) => void;
}

const EvidenceUploader: React.FC<EvidenceUploaderProps> = ({
  imageFiles,
  videoFiles,
  onAddImages,
  onRemoveImage,
  onAddVideos,
  onRemoveVideo,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Evidence</h3>
      <Tabs defaultValue="images">
        <TabsList className="w-full">
          <TabsTrigger value="images" className="flex-1">
            <ImageIcon className="h-4 w-4 mr-2" />
            Images
          </TabsTrigger>
          <TabsTrigger value="videos" className="flex-1">
            <VideoIcon className="h-4 w-4 mr-2" />
            Videos
          </TabsTrigger>
        </TabsList>
        <TabsContent value="images" className="pt-4">
          <FileInput
            id="image-upload"
            accept="image/png,image/jpeg,image/jpg,image/gif"
            multiple
            selectedFiles={imageFiles}
            onFilesSelected={onAddImages}
            onFileRemove={onRemoveImage}
            maxFiles={5}
          />
        </TabsContent>
        <TabsContent value="videos" className="pt-4">
          <FileInput
            id="video-upload"
            accept="video/mp4,video/quicktime,video/webm"
            multiple
            selectedFiles={videoFiles}
            onFilesSelected={onAddVideos}
            onFileRemove={onRemoveVideo}
            maxFiles={2}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EvidenceUploader;
